import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { compose } from 'recompose';
import SvgIcon from 'wfui-digital-core/es/SvgIcon';
import accessibleIcon from 'wfui-digital-core/es/accessibleIcon';

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-339.000000, -24.000000)",
    fill: "#3B3331"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(339.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.999995, 6.000012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "\n                    M10,8.41304532 L18.08395,0.328798518 C18.522204,-0.109471832 19.2327263,-0.109618157 19.6711608,0.328471648\n                    C20.109383,0.766349376 20.1096623,1.47656871 19.6717845,1.91479093 L19.6714875,1.91508806 L11.586889,9.99998849\n                    L19.6714875,18.0848889 C20.1095294,18.5229471 20.1095161,19.2331665 19.6714579,19.6712083 L19.6711608,19.6715053\n                    C19.2327263,20.1095951 18.522204,20.1094488 18.08395,19.6711785 L10,11.5869317 L1.91606021,19.6711785\n                    C1.47780623,20.1094488 0.767283906,20.1095951 0.328849445,19.6715053 C-0.109372774,19.2336276 -0.109652038,18.5234083\n                    0.32822569,18.085186 L0.328522696,18.0848889 L8.41312121,9.99998849 L0.328522696,1.91508805 C-0.109519132,1.47702987\n                    -0.109505871,0.76681048 0.328552315,0.328768653 L0.328849444,0.328471647 C0.767283905,-0.109618158 1.47780623,-0.109471833\n                    1.91606021,0.328798517 L10,8.41304532 L10,8.41304532 Z\n                  "
  })))))));
};

CloseIcon.defaultProps = {
  width: '32px',
  height: '32px'
};
export default /*#__PURE__*/React.memo(compose(accessibleIcon)(CloseIcon));